import { post, get, put, deleteApi } from './axiosFun';

// 线下培训 分页
export const offlinePage = (params) => { return post("/train/offline-train-plan/page", params) };

// 线下培训 列表
export const offlineList = (params) => { return post("/train/offline-train-plan/list", params) };

export const offlineExport = (params) => { return post("/train/offline-train-plan/list", params, { responseType: 'blob', isExport: true }) };


// 线下培训 编辑
export const offlineEdit = (params) => { return put("/train/offline-train-plan/edit", params) };

// 线下培训 新增
export const offlineAdd = (params) => { return post("/train/offline-train-plan/add", params) };

// 线下培训 详情
export const offlineDetails = (offlineTrainPlanId) => { return get(`/train/offline-train-plan/detail/${offlineTrainPlanId}`) };

// 线下培训 发布
export const offlinePublish = (params) => { return post("/train/offline-train-plan/publish", params) };

// 线下培训 获取发布状态
export const offlinePublishStatus = (planId) => { return get(`/train/offline-train-plan/publishStatus/${planId}`) };

// 线下培训 删除
export const offlineRemove = (params) => { return deleteApi("/train/offline-train-plan/remove", params) };

// 线下培训 上传培训结果
export const offlineResultUpload = (params) => { return post("/train/offline-train-plan/resultUpload", params) };



// WEBPACK FOOTER //
// ./src/api/offline.js